module.exports = __webpack_public_path__ + "static/media/mith.7f0d7cfc.svg";